<template>
  <div>
    <el-upload
      ref="upload"
      :accept="acceptExts[format]"
      list-type="picture-card"
      :file-list="fileList"
      :show-file-list="true"
      :auto-upload="true"
      :data="access"
      :action="action"
      :multiple="multiple"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-remove="onRemoveHandler"
      :on-progress="onProgress"
      :on-success="onSuccessHandler"
      :on-error="onError"
      :class="{'hide-uploader': hideUploader}"
      :on-exceed="onExceed"
    >
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip">{{tip}}</div>
    </el-upload>
  </div>
  <!-- el-upload.newthumbnail-uploader(
  
)
  .el-upload__tip(slot='tip') {{tip}}
  //- img.thumbnail(v-if='files', :src='files')
  i.el-icon-plus.newthumbnail-uploader-icon-->
</template>

<script>
import Vue from "vue";
import Newuploader from "lib/mixins/Newuploader";

export default {
  name: "oss-newthumbnail",
  mixins: [Newuploader],
  props: {
    format: {
      type: String,
      default: "image"
    },
    tip: {
      type: String
    },
    count: {
      type: Number,
      default: 1
    },
    maxHeight: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      limit: 1,
      isNeedSave: 1, // 1 保存为封面、头像等不在课件中展示
      acceptExts: {
        image: ".jpg,.jpeg,.png",
        file: ".jpg,.jpeg,.png,.gif,.zip,.pdf"
      },
      acceptTypes: ["image/png", "image/jpeg"],
      hideUploader: false,
      multiple: false,
      docId: "",
      docUrl: ""
    };
  },
  watch: {
    //
  },
  created() {
    if (this.count != 1) {
      this.limit = this.count;
      this.multiple = true;
    } else {
      this.limit = 2;
    }
  },
  beforeDestroy() {
    this.fileList = [];
  },
  methods: {
    beforeUpload(file) {
      var that = this;
      if (this.format === "image") {
        let isPngJpg = this.acceptTypes.includes(file.type);
        if (!isPngJpg) {
          this.$message.info({
            title: file.name,
            message: "只能上传 PNG / JPG 格式的图片"
          });
          return false;
        }
      }

      var fileData = file;
      //读取图片数据
      return new Promise(resolve => {
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result;
          //加载图片获取图片真实宽度和高度
          var image = new Image();
          image.src = data;
          image.onload = function() {
            var width = image.width;
            var height = image.height;
            if (image.width < that.maxWidth && image.height < that.maxHeight) {
                debugger;
              if (that.count === 1) {
                let f = that.$refs.upload.uploadFiles;
                if (f.length > 1) {
                  let uf = f[0];
                  console.log(uf);
                  that.$refs.upload.handleRemove(uf);
                  // this.fileList.shift();
                }
              }
              that.addFile(file).then(resolve);
              // reader.readAsDataURL(fileData);
              // return;
            } else {
              that.$message.warning(
                "上传图片必须小于等于:" + that.maxWidth + "*" + that.maxHeight
              );
              that.files = [];
              return false;
            }
          };
          // image.src= data;
        };
        reader.readAsDataURL(fileData);
      });
    },
    onExceed(files, fileList) {
      this.$message.warning(
        `本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件, 超出单次最大上传文件 ${this.limit} 个的限制`
      );
    },
    onRemoveHandler() {
      if (this.onRemove) {
        this.onRemove();
      }
    },
    onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
        this.$emit("update:docId", res.docId);
      }
    }
  }
};
</script>
<style lang="scss">
.thumbnail-uploader {
  .el-upload-list--picture-card {
    .el-upload-list__item {
      width: 200px;
      height: 120px;
    }
  }
  .thumbnail-uploader-icon {
    margin-top: 0;
    font-size: 40px;
  }
  .el-upload--picture-card {
    width: 200px;
    height: 120px;
  }
}
</style>
